import axios from 'axios';

// const API_KEY = 'xpM_ED>q8{6!a5^v3}Zhk';
const API_KEY = '_X@ZBRwcmi:y]Dr*mvpD4!?8m988cf:U^r^?x]F3:siiFwtN}C';

/** Spring Boot API — update if your backend host/port differs */
export const BACKEND_URL = 'https://api.whosapp.xyz';

function resolveBaseUrl() {
	if (typeof window === 'undefined') {
		return BACKEND_URL;
	}
	const { hostname } = window.location;
	const isLocalhost =
		hostname === 'localhost' ||
		hostname === '127.0.0.1' ||
		hostname === '[::1]';
	// Local dev (any port) — relative URLs go through webpack proxy to avoid CORS
	if (isLocalhost) {
		return '';
	}
	return BACKEND_URL;
}

axios.defaults.baseURL = resolveBaseUrl();
axios.defaults.withCredentials = true;
axios.defaults.headers['X-API-KEY'] = API_KEY;

export default axios;
